// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopTitle_wrapper__3ayBB"};